import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStars01Gradient = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6223 1.0941C10.5233 0.836634 10.2759 0.666748 10.0001 0.666748C9.72423 0.666748 9.47687 0.836634 9.37785 1.0941L8.5921 3.13704C8.39183 3.65774 8.3289 3.80778 8.24282 3.92885C8.15645 4.05032 8.05032 4.15645 7.92885 4.24282C7.80778 4.3289 7.65774 4.39183 7.13704 4.5921L5.09409 5.37785C4.83663 5.47687 4.66675 5.72423 4.66675 6.00008C4.66675 6.27593 4.83663 6.52329 5.09409 6.62231L7.13704 7.40806C7.65774 7.60833 7.80778 7.67126 7.92885 7.75734C8.05032 7.84371 8.15645 7.94984 8.24282 8.07132C8.3289 8.19238 8.39183 8.34243 8.5921 8.86312L9.37785 10.9061C9.47687 11.1635 9.72423 11.3334 10.0001 11.3334C10.2759 11.3334 10.5233 11.1635 10.6223 10.9061L11.4081 8.86312C11.6083 8.34243 11.6713 8.19238 11.7573 8.07132C11.8437 7.94984 11.9498 7.84371 12.0713 7.75734C12.1924 7.67126 12.3424 7.60833 12.8631 7.40806L14.9061 6.62231C15.1635 6.52329 15.3334 6.27593 15.3334 6.00008C15.3334 5.72423 15.1635 5.47687 14.9061 5.37785L12.8631 4.5921C12.3424 4.39183 12.1924 4.3289 12.0713 4.24282C11.9498 4.15645 11.8437 4.05032 11.7573 3.92885C11.6713 3.80778 11.6083 3.65774 11.4081 3.13704L10.6223 1.0941Z",
			fill: "url(#paint0_linear_3321_11234)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.9297 8.3686C4.81677 8.14275 4.58593 8.00008 4.33341 8.00008C4.0809 8.00008 3.85006 8.14275 3.73713 8.36861L3.21416 9.41455C3.02583 9.7912 2.96845 9.89958 2.89872 9.99004C2.82878 10.0808 2.74744 10.1621 2.65671 10.2321C2.56625 10.3018 2.45786 10.3592 2.08122 10.5475L1.03527 11.0705C0.809416 11.1834 0.666748 11.4142 0.666748 11.6667C0.666748 11.9193 0.809416 12.1501 1.03527 12.263L2.08122 12.786C2.45786 12.9743 2.56625 13.0317 2.65671 13.1014C2.74744 13.1714 2.82878 13.2527 2.89872 13.3435C2.96845 13.4339 3.02583 13.5423 3.21416 13.9189L3.73713 14.9649C3.85006 15.1907 4.0809 15.3334 4.33341 15.3334C4.58593 15.3334 4.81677 15.1907 4.9297 14.9649L5.45267 13.9189C5.64099 13.5423 5.69838 13.4339 5.76811 13.3435C5.83805 13.2527 5.91939 13.1714 6.01012 13.1014C6.10058 13.0317 6.20897 12.9743 6.58561 12.786L7.63156 12.263C7.85741 12.1501 8.00008 11.9193 8.00008 11.6667C8.00008 11.4142 7.85741 11.1834 7.63156 11.0705L6.58561 10.5475C6.20897 10.3592 6.10058 10.3018 6.01012 10.2321C5.91939 10.1621 5.83805 10.0808 5.76811 9.99004C5.69838 9.89958 5.64099 9.7912 5.45267 9.41455L4.9297 8.3686Z",
			fill: "url(#paint1_linear_3321_11234)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3321_11234",
			x1: .66652,
			y1: 15.3333,
			x2: 15.3332,
			y2: .666569,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF6C6C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DD7BFF"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_3321_11234",
			x1: .66652,
			y1: 15.3333,
			x2: 15.3332,
			y2: .666569,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF6C6C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DD7BFF"
			})]
		})] })
	]
});
export default SvgStars01Gradient;
